import bonusBuyComponent from 'components/bonus-buy/bonus-buy-component';
import { playBackgroundAnimation, setFullScreenCelebrationFilter } from 'components/ui-helper';
import WildStickyRecorder from 'integration/wild-sticky-record';
import doSettingsModel from 'model/do-settings-model';
import { GameType, GF_CANVAS_SIZES, GFCustomLayers } from 'names/do-names';
import Components from 'slotworks/components/components';
import ReelSpinner from 'slotworks/components/matrix/reel/transition-behaviours/spin/reel-spinner';
import CanvasManager from 'slotworks/graphics/canvas/canvas-manager';
import Layers from 'slotworks/graphics/layers/layers';
import currency from 'slotworks/i18n/currency';
import Translations from 'slotworks/i18n/translations';
import RevolverInit from 'slotworks/integration/revolver/states/revolver-init';
import BetModel from 'slotworks/model/bets/bet-model';
import settingsModel, { Jurisdiction } from 'slotworks/model/settings/settings-model';
import soundManager from 'slotworks/sound/sound-manager';
import stateMachine from 'slotworks/state-machine/state-machine';
import { AddWindowFocusChangeLsitener } from 'slotworks/utils/browser-utils';
import deviceInfo from 'slotworks/utils/device-info';
import * as TweenJS from 'slotworks/utils/tween';
import CelebrateWinsComponent from 'transitions/celebrate-win-component';
import WildSticky from './wild-sitcky';
import NotificationPopup from 'components/promo-popups/notification-popup';
import { Graphics } from 'pixi.js';
import PortraitMessages from 'components/messages/portrait-messages';
import Timer from 'slotworks/utils/timer';
import translations from 'slotworks/i18n/translations';
import betModel from 'slotworks/model/bets/bet-model';
import autoplayModel from 'slotworks/model/autoplay-model';

declare const __VERSION__: string;
export default class GameInit extends RevolverInit {
    public static freeSpinLoaded: boolean;
    static leftHanded: boolean;
    static onGameIntro: boolean = false;
    static gameType: GameType = GameType.default;
    static freespinBigwin: boolean = false;
    static freeSpinsWin: number = 0;
    protected portraitScale: number = GF_CANVAS_SIZES.DEFAULT_PORTRAIT_SCALE;
    static celebrateWin = new CelebrateWinsComponent();
    public static cloudAnimations: TweenJS.Tween[];
    public static wildStickyRecorder: WildStickyRecorder;
    private anticipationFilter: Graphics;

    public complete() {
        this.updateParticles();

        GameInit.freeSpinLoaded = false;

        Components.betBar.onBetUpdated.add(onBetUpdated);
        Components.betMenu.onBetOptionsCommitted.add(onBetUpdated);

        ReelSpinner.anticipationLayer = Layers.Custom.get(GFCustomLayers.ANTICIPATION);
        Components.matrix.landSignal.add((index: number) => this.onLandSignal(index));
        Components.matrix.anticipateStartSignal.add((index: number) => this.onAnticipateStartSignal(index));
        Components.matrix.startSignal.add((index: number) => this.onStartSignal(index));
        Layers.MenusContent.onSceneEnter.add(() => this.onMenuSceneEnter);
        Layers.Paylines.container.visible = false;


        if (!deviceInfo.isDesktop) {
            const homeURL = settingsModel.homeURL;
            if (homeURL === "close" || homeURL === "" || homeURL === undefined || homeURL === null) {
                var el: any = document.querySelector("#block_sound");
                el.style.display = "none";
            }
        }

        Layers.PaytableContent.onSceneEnter.add((scene: string) => {
            const betText = Layers.PaytableContent.getFlexiText('max_min') || Layers.PaytableContent.getFlexiText("bet_text");
            if (betText) {
                let betOptions = BetModel.generateBetOptions();
                const minBet = currency.format(betOptions.coinSizes[0] * betOptions.stakePerLineValues[0] * betOptions.lines);
                const maxBet = currency.format(betOptions.coinSizes.slice(-1)[0] * betOptions.stakePerLineValues.slice(-1)[0] * betOptions.lines);
                const minBetTranslation = Translations.get('min_bet');
                const maxBetTranslation = Translations.get('max_bet');
                let text = `${minBetTranslation} <yellow>${minBet}</yellow> | ${maxBetTranslation} <yellow>${maxBet}</yellow>`;
                betText.setText(text);
            }
        });

        Components.betBar.onBetUpdated.addOnce(() => {
            const notification = new NotificationPopup();
            notification.show();
        });

        super.complete();

        Layers.MenusContent.onSceneEnter.add(() => {
            const rulesText = Layers.MenusContent.getFlexiText("rules_body");
            const rtp = (settingsModel as any).rtp_total;
            if (rulesText) {
                if(settingsModel.isJurisdiction([Jurisdiction.UK, Jurisdiction.DE, Jurisdiction.NL]) || autoplayModel.autoplayDisabled) {
                    rulesText.setText(translations.get("pays_game_rules_jurisdiction", {version: __VERSION__, rtp_total: rtp + ""}));
                } else if(settingsModel.socialSweepstakes && settingsModel.rtpdisplay === false) {
                    rulesText.setText(Translations.get("pays_game_rules_nortp", {version: __VERSION__, rtp_total: rtp + ""}));
                } else {
                    rulesText.setText(translations.get("rm.bod", {version: __VERSION__, rtp_total: rtp + ""}));
                }
            }
        });

        if (!deviceInfo.isDesktop) {
            CanvasManager.onOrientationChange.add(this.onOrientationChange, this);

            Layers.Prompts.onSceneEnter.add((scene: string) => {
                if(scene == "enter_freespins" || scene == "exit_freespins" || scene == "freespins_retrigger") {
                    Layers.SmartButton.hide();
                }
            });
            Layers.Prompts.onSceneExit.add((scene: string) => {
                if(scene == "enter_freespins" || scene == "exit_freespins" || scene == "freespins_retrigger") {
                    Layers.SmartButton.show();
                }
            });
            Layers.Bonus.onSceneEnter.add((scene: string) => {
                if(scene == "bonus") {
                    Layers.SmartButton.hide();
                }
            });
            Layers.Bonus.onSceneExit.add((scene: string) => {
                if(scene == "bonus") {
                    Layers.SmartButton.show();
                }
            });

            PortraitMessages.start();
        }

        const rightGun = Layers.MatrixForeground.getAnimatedSprite('right_gun');
        rightGun?.scale.set(-1, 1);

        if (deviceInfo.isDesktop && !settingsModel.isJurisdiction([Jurisdiction.UK, Jurisdiction.DE, Jurisdiction.NL])) {
            this.setSpaceToConstantSpin();
        }

        this.stopSmokeParticle();
        playBackgroundAnimation();

        if (!settingsModel.isUKJurisdiction() && doSettingsModel.buyout) {
            bonusBuyComponent.start();
            bonusBuyComponent.setEnabled(true);
        }

        Timer.setTimeout(() => {
            if (GameInit.gameType === GameType.default && !GameInit.onGameIntro)
            soundManager.customEvent("start_background_ambience");
        }, 100);
    }

    private onLandSignal(index: number) {
        if (index === 5) {
            this.playSmokeParticle();
        }
        this.disableAllAnticipation();
        WildSticky.onLandWildStickyBehaviour(index);
    }

    private playGunAnimation() {
        const leftGun = Layers.MatrixForeground.getAnimatedSprite('left_gun');
        const rightGun = Layers.MatrixForeground.getAnimatedSprite('right_gun');
        rightGun?.gotoAndPlay(0);
        leftGun?.gotoAndPlay(0);
    }

    private onAnticipateStartSignal(index: number) {
        const anticiationLayer = ReelSpinner.anticipationLayer as Layers;
        for (let i = 0; i < 5; i++) {
            const anticipation = anticiationLayer.getAnimatedSprite('anticipation_' + (i + 1));
            const anticipationFilter = anticiationLayer.getAnimatedSprite('anticipation_bg_loop_0' + (i + 1));
            if (anticipation) {
                anticipation.visible = false;
                anticipation.stop();
            }
            if (anticipationFilter) {
                anticipationFilter.visible = false;
                anticipationFilter.stop();
            }
        }

        const currentAnticipation = anticiationLayer.getAnimatedSprite('anticipation_' + index);
        const currentFilterAnticipation = anticiationLayer.getAnimatedSprite('anticipation_bg_loop_0' + index);
        
        if (currentAnticipation) {
            currentAnticipation.visible = true;
            currentAnticipation.gotoAndPlay(0);
        }
        if (currentFilterAnticipation) {
            currentFilterAnticipation.visible = true;
            currentFilterAnticipation.gotoAndPlay(0);
        }
    }

    private setSpaceToConstantSpin() {
        const onKeyDown = (event: any) => {
            if (settingsModel.getSpaceToSpin() && doSettingsModel.spaceToContinueSpinAndSkip) {
                if (event.keyCode === 32) {
                    doSettingsModel.spacePressed = true;
                    if (stateMachine.currentState.node.name !== 'show-win-line') {
                        stateMachine.skip();
                    }
                }
            }
        };
        const onKeyUp = (event: any) => {
            if (event.keyCode === 32) {
                doSettingsModel.spacePressed = false;
            }
        };
        const onWindowFocusChange = (focused: boolean) => {
            doSettingsModel.spacePressed = false;
        };
        AddWindowFocusChangeLsitener(onWindowFocusChange);
        document.addEventListener('keyup', onKeyUp);
        document.addEventListener('keydown', onKeyDown);
    }

    private onMenuSceneEnter() {
        const rulesText = Layers.MenusContent.getFlexiText('rules_body');
        if (rulesText) {
            if (settingsModel.isJurisdiction([Jurisdiction.UK, Jurisdiction.DE, Jurisdiction.NL])) {
                rulesText.setText(Translations.get('pays_game_rules_jurisdiction', { version: __VERSION__ }));
            }
        }
    }

    private onStartSignal(index: number) {
        Components.matrix.resetSymbolPositions();
        this.playGunAnimation();
        WildSticky.onSpin();
        this.disableAllAnticipation();
    }

    public disableAllAnticipation() {
        for (let i = 0; i < 5; i++) {
            const anticipation = Layers.Custom.get(GFCustomLayers.ANTICIPATION).getAnimatedSprite('anticipation_' + (i + 1));
            const anticipationFilter = Layers.Custom.get(GFCustomLayers.ANTICIPATION).getAnimatedSprite('anticipation_bg_loop_0' + (i + 1));
            if (anticipation) {
                anticipation.visible = false;
                anticipation.stop();
            }
            if (anticipationFilter) {
                anticipationFilter.visible = false;
                anticipationFilter.stop();
            }
        }
    }

    private playSmokeParticle() {
        const smoke = Layers.MatrixForeground.getParticle('smokeparticle');
        smoke.emit = true;
    }

    private stopSmokeParticle() {
        const smoke = Layers.MatrixForeground.getParticle('smokeparticle');
        smoke.cleanup();
        smoke.emit = false;
    }

    public onOrientationChange() {
        Components.matrix.resetSymbolPositions();
        playBackgroundAnimation();
        setFullScreenCelebrationFilter();

        const rightGun = Layers.MatrixForeground.getAnimatedSprite('right_gun');
        rightGun?.scale.set(-1, 1);
        WildSticky.onOrientationChange();
    }

    // updating textures and setting the particle config
    private updateParticles() {
        if(settingsModel.socialSweepstakes) {
            Object.keys(Components.config.particles).forEach((key: string) => {
                const config = Components.config.particles[key];
                for(let textures of config.textures) {
                    
                    const textureArr = (textures as any)?.textures as string[];
                    
                    if(textureArr && textureArr.length) {
                        for(let i = 0; i < textureArr.length; i++) {
                            if(regParticle.test(textureArr[i])) {
                                textureArr[i] = textureArr[i].replace(regularParticleTexture, socialParticleTexture);
                            }
                        }
                    }
                }
            });
        }
    }
}

export function onBetUpdated(value: any) {
    setTimeout(() => WildSticky.onBetUpdated(), 1);
}

const regularParticleTexture = "particles";
const socialParticleTexture = "DO_hd_Coin_Rotate_Social";
const regParticle = /^particles\/\d+$/;



// WEBPACK FOOTER //
// ./src/states/game-init.ts